import { Route, Routes } from "react-router-dom";

import {
  AllPostJobs,
  EngineeringJobs,
  LandingPage,
  NonProtectedShared,
  Registration,
} from "./nonProtectedRoutes";
import { Error } from "../pages";
import { SinglePostJobPage } from "./protectedRoutes";
import { JobPostsHeader } from "../components/allPostjobs";

const NonProtectedRoute = () => {
  return (
    <Routes>
      <Route path="" element={<LandingPage />} />
      <Route path="register" element={<Registration />} />

      <Route path="/" element={<NonProtectedShared />}>
        <Route path="all-post-jobs" element={<JobPostsHeader />}>
          <Route index element={<AllPostJobs />} />
          <Route path="engineering-jobs" element={<EngineeringJobs />} />
        </Route>

        <Route
          path="all-post-jobs/:jobID"
          element={<SinglePostJobPage loaderContainer="unprotected__loader" />}
        />
      </Route>

      <Route path="*" element={<Error />} />
    </Routes>
  );
};

export default NonProtectedRoute;
